import { faCheck as fasCheck } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListUi3, ListUi3Item } from "bm-ui-kit";
import type { ReactNode } from "react";
import type { PersonalLoanCalculatorVariant } from "../Calculator/types";

const USP_CONFIG = {
	CAR_LOAN: {
		mobile: [
			<>
				<strong className="text-primary">Nem kell fedezet</strong>ként felajánlanod a megvásárolt kocsit
			</>,
			<>
				Folyósítás akár <strong className="text-primary">1 munkanap</strong> alatt,
			</>,
			<> Felveheted a hitelt, még mielőtt megtalálnád álmaid autóját </>,
		],
		desktop: [
			<>
				<strong className="text-primary">Nem kell fedezet</strong>ként felajánlanod a megvásárolt kocsit
			</>,
			<>
				Folyósítás akár <strong className="text-primary">1 munkanap</strong> alatt,
			</>,
			<> Felveheted a hitelt, még mielőtt megtalálnád álmaid autóját </>,
			<>
				Akár <strong className="text-primary">15 millió</strong> Ft és{" "}
				<strong className="text-primary">egyedi kedvezményeket</strong> is biztosítunk
			</>,
			<>
				<strong className="text-primary">Az autó kezdetektől fogva a te tulajdonodba kerül</strong>, nem
				úgy,mint lízing esetén
			</>,
			<>
				Az autókölcsön egy <strong className="text-primary">fix kamatozású hitel</strong>, a bank nem
				módosíthatja a havi törlesztőd
			</>,
		],
	},
	HOME_RENOVATION: {
		mobile: [
			<>
				Folyósítás akár <strong className="text-primary">1 munkanap</strong> alatt
			</>,
			<>
				Akár <strong className="text-primary">15 millió</strong> Ft és akár{" "}
				<strong className="text-primary">egyedi kedvezményeket</strong> is biztosítunk.
			</>,
			<>Mi segítünk a hitelfelvételben, Te foglalkozz a felújítással</>,
		],
		desktop: [
			<>
				Folyósítás akár <strong className="text-primary">1 munkanap</strong> alatt
			</>,
			<>
				Akár <strong className="text-primary">15 millió</strong> Ft és akár{" "}
				<strong className="text-primary">egyedi kedvezményeket</strong> is biztosítunk.
			</>,
			<>Mi segítünk a hitelfelvételben, Te foglalkozz a felújítással</>,
		],
	},
	CREDIT_EXCHANGE: [
		{
			mobile: [
				<>
					Összegyúrjuk a hiteleidet és elegendő <strong className="text-primary">1 helyre fizetned</strong>
				</>,
				<>
					<strong className="text-primary">Kitolható a futamidő</strong> és akár{" "}
					<strong className="text-primary">extra pénzt</strong> is kaphatsz
				</>,
				<>
					Százezreket, vagy akár <strong className="text-primary">milliókat is spórolhatsz</strong>
				</>,
			],
			desktop: [
				<>
					Összegyúrjuk a hiteleidet és elegendő <strong className="text-primary">1 helyre fizetned</strong>
				</>,
				<>
					<strong className="text-primary">Kitolható a futamidő</strong> és akár{" "}
					<strong className="text-primary">extra pénzt</strong> is kaphatsz
				</>,
				<>
					Százezreket, vagy akár <strong className="text-primary">milliókat is spórolhatsz</strong>
				</>,
				<>
					Folyósítás akár <strong className="text-primary">1 munkanap</strong> alatt
				</>,
				<>
					Akár <strong className="text-primary">15 millió</strong> Ft fedezet nélkül
				</>,
				<>
					<strong className="text-primary">Egyedi kedvezményeket</strong> is biztosítunk.
				</>,
			],
		},
	],
};
const DEFAULT_CONFIG = [
	{
		mobile: [
			<>
				Folyósítás akár <strong className="text-primary">1 munkanap</strong> alatt.
			</>,
			<>
				Akár <strong className="text-primary">15 millió</strong> Ft fedezet nélkül
			</>,
			<>
				<strong className="text-primary">Egyedi kedvezményeket</strong> is biztosítunk.
			</>,
		],
		desktop: [
			<>
				Folyósítás akár <strong className="text-primary">1 munkanap</strong> alatt.
			</>,
			<>
				Akár <strong className="text-primary">15 millió</strong> Ft fedezet nélkül
			</>,
			<>
				<strong className="text-primary">Egyedi kedvezményeket</strong> is biztosítunk.
			</>,
			<>
				Szolgáltatásunk teljesen <strong className="text-primary">díjmentes</strong>
			</>,
			<>
				Egyszerű és <strong className="text-primary">gyors online ügyintézés</strong>
			</>,
			<>Szakértőnk minden kérdésedre választ ad</>,
		],
	},
];

export function getDefaultConfigForBankSites(bank: string): ReactNode[] {
	if (!bank) {
		return [
			<>
				Folyósítás akár <strong className="text-primary">1 munkanap</strong> alatt.
			</>,
			<>
				Akár <strong className="text-primary">15 millió</strong> Ft fedezet nélkül
			</>,
			<>
				<strong className="text-primary">Egyedi kedvezményeket</strong> is biztosítunk.
			</>,
			<>
				Szolgáltatásunk teljesen <strong className="text-primary">díjmentes</strong>
			</>,
			<>
				Egyszerű és <strong className="text-primary">gyors online ügyintézés</strong>
			</>,
			<>Szakértőnk minden kérdésedre választ ad</>,
		];
	}
	switch (bank) {
		case "cib":
			return [
				<>
					Folyósítás akár <strong className="text-primary">1-3 munkanap</strong> alatt.
				</>,
				<>
					Akár <strong className="text-primary">15 millió</strong> Ft fedezet nélkül
				</>,
				<>
					Akár <strong className="text-primary">5 évig díjmentes bankszámlával</strong>, de igényelheted{" "}
					<strong className="text-primary">számlanyitás nélkül is</strong>.
				</>,
				<>
					Szolgáltatásunk teljesen <strong className="text-primary">díjmentes</strong>
				</>,
				<>
					Egyszerű és <strong className="text-primary">gyors online ügyintézés</strong>
				</>,
				<>Szakértőnk minden kérdésedre választ ad</>,
			];
		case "erste":
			return [
				<>
					Folyósítás akár <strong className="text-primary">1 munkanap alatt online igénylésnél</strong>.
				</>,
				<>
					Akár <strong className="text-primary">15 millió</strong> Ft fedezet nélkül
				</>,
				<>
					Akár <strong className="text-primary">3 évig díjmentes bankszámlával</strong>, de igényelheted{" "}
					<strong className="text-primary">számlanyitás nélkül is</strong>.
				</>,
				<>
					Szolgáltatásunk teljesen <strong className="text-primary">díjmentes</strong>
				</>,
				<>
					Egyszerű és <strong className="text-primary">gyors online ügyintézés</strong>
				</>,
				<>Szakértőnk minden kérdésedre választ ad</>,
			];
		case "kh":
			return [
				<>
					Folyósítás akár <strong className="text-primary">1 munkanap</strong> alatt.
				</>,
				<>
					Akár <strong className="text-primary">10 millió</strong> Ft fedezet nélkül
				</>,
				<>
					Szolgáltatásunk teljesen <strong className="text-primary">díjmentes</strong>
				</>,
				<>
					Egyszerű és <strong className="text-primary">gyors online ügyintézés</strong>
				</>,
				<>Szakértőnk minden kérdésedre választ ad</>,
			];
		case "mbh":
			return [
				<>
					Folyósítás akár <strong className="text-primary">2 munkanap</strong> alatt.
				</>,
				<>
					Akár <strong className="text-primary">10 millió</strong> Ft fedezet nélkül
				</>,
				<>
					<strong className="text-primary">Egyedi kedvezmények közszférában dolgozók számára</strong>.
				</>,
				<>
					Szolgáltatásunk teljesen <strong className="text-primary">díjmentes</strong>
				</>,
				<>
					Egyszerű és <strong className="text-primary">gyors online ügyintézés</strong>
				</>,
				<>Szakértőnk minden kérdésedre választ ad</>,
			];
		case "otp":
			return [
				<>
					Folyósítás akár <strong className="text-primary">1 munkanap</strong> alatt.
				</>,
				<>
					Akár <strong className="text-primary">12 millió</strong> Ft fedezet nélkül
				</>,
				<>
					<strong className="text-primary">Egyedi kedvezményeket</strong> is biztosítunk.
				</>,
				<>
					Szolgáltatásunk teljesen <strong className="text-primary">díjmentes</strong>
				</>,
				<>
					Egyszerű és <strong className="text-primary">gyors online ügyintézés</strong>
				</>,
				<>Szakértőnk minden kérdésedre választ ad</>,
			];
		case "raiffeisen":
			return [
				<>
					Folyósítás akár <strong className="text-primary">1-3 munkanap</strong> alatt.
				</>,
				<>
					Akár <strong className="text-primary">12 millió</strong> Ft fedezet nélkül
				</>,
				<>
					<strong className="text-primary">Díjmentes bankszámlával igényelhető</strong>.
				</>,
				<>
					Szolgáltatásunk teljesen <strong className="text-primary">díjmentes</strong>
				</>,
				<>
					Egyszerű és <strong className="text-primary">gyors online ügyintézés</strong>
				</>,
				<>Szakértőnk minden kérdésedre választ ad</>,
			];
		case "unicredit":
			return [
				<>
					Folyósítás akár <strong className="text-primary">1 munkanap</strong> alatt.
				</>,
				<>
					Akár <strong className="text-primary">12 millió</strong> Ft fedezet nélkül
				</>,
				<>
					Akár <strong className="text-primary">2 évig díjmentes bankszámlával</strong>.
				</>,
				<>
					Szolgáltatásunk teljesen <strong className="text-primary">díjmentes</strong>
				</>,
				<>
					Egyszerű és <strong className="text-primary">gyors online ügyintézés</strong>
				</>,
				<>Szakértőnk minden kérdésedre választ ad</>,
			];

		default:
			return null;
	}
}

type DeviceType = "desktop" | "mobile";

interface UspListProps {
	items: string[];
	classNames: string;
}
const UspList: React.FC<UspListProps> = ({ items, classNames }) => {
	return (
		<ListUi3 gutterSize="sm" className={classNames}>
			{items.map((item, index) => {
				return (
					<ListUi3Item key={index} listItemStyle={<FontAwesomeIcon icon={fasCheck} className="mr-2" />}>
						{item}
					</ListUi3Item>
				);
			})}
		</ListUi3>
	);
};

const getDeviceClassName = (device: DeviceType) => {
	return device === "mobile" ? "d-lg-none" : "d-md-hide";
};

const getItems = (variant: PersonalLoanCalculatorVariant, device: DeviceType, bank: string): string[] => {
	const items = USP_CONFIG[variant] ?? {
		mobile: DEFAULT_CONFIG[0].mobile,
		desktop: getDefaultConfigForBankSites(bank),
	};

	if (Array.isArray(items)) {
		const first = items[0];
		return first?.[device] ?? [];
	}

	return items[device] ?? [];
};

const getUspTexts = (variant: PersonalLoanCalculatorVariant, device: DeviceType, bank: string) => {
	const classNames = getDeviceClassName(device);
	const items = getItems(variant, device, bank);

	return <UspList items={items} classNames={classNames} />;
};
export default getUspTexts;
